/*======  Define import  ======*/
/*------  React ------*/
import React, { useEffect, useState, useContext, createContext } from "react";
/*------  Amplify ------*/
import { Auth, I18n } from "aws-amplify";
/*------ Compornent Js/Jsx ------*/
import { outputLog } from "./CommonFunction";
/*======  Define global variables/functions   ======*/
const consoleLogOutput = false;	//コンソールログ個別出力制御用

/*------ Contextの作成 ------*/
const authContext = createContext();	//認証用

/*------ 認証状態をチェックしContextを更新 ------*/
export const useAuth = () => {
	return useContext(authContext);
};

/*------ 認証用Provider ------*/
export const ProvideAuth = ({ children }) => {
	const auth = useProvideAuth();
	return (
		<authContext.Provider value={auth}>{children}</authContext.Provider>
	);
};

/*------ 認証用Providerの実体 ------*/
const useProvideAuth = () => {

	consoleLogOutput && (console.log("useProvideAuth IN", consoleLogOutput));

	/*------ State作成 ------*/
	const [isLoading, setIsLoading] = useState(true);
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [username, setUsername] = useState("");			//ID(cognitoユーザー識別子)
	const [email, setEmail] = useState("");					//email
	const [password, setPassword] = useState("");			//password
	const [familyname, setFamilyName] = useState("");		//苗字
	const [givenname, setGivenName] = useState("");			//名前
	const [organization, setOrganization] = useState("");	//組織
	const [role, setRole] = useState("");					//ロール
	// const [sub, setSub] = useState("");						//ID(cognitoユーザー識別子)


	useEffect(() => {
		/*------ Cognitoから認証情報を取得 ------*/
		Auth.currentAuthenticatedUser()
			.then((user) => {	//正常
				// setSub(user.attributes.sub)
				consoleLogOutput && (console.log("use-auth useProvideAuth Auth.currentAuthenticatedUser OK", consoleLogOutput));

				/*------ Stateの更新 ------*/
				setIsAuthenticated(true);
				setIsLoading(false);
			})
			.catch((error) => {	//異常
				consoleLogOutput && (console.log("use-auth useProvideAuth Auth.currentAuthenticatedUser not yet", consoleLogOutput));

				/*------ Stateの更新 ------*/
				setIsAuthenticated(false);
				setIsLoading(false);
			});

	// }, [setIsAuthenticated]);
	}, [isLoading]);


	/*------ ユーザー情報取得 ------*/

	/*------ signUp ------*/
	/* パラメーター　1:username(SignIn ID) / ２:パスワード / 3:email / 4:苗字 /5:名前 / 6:組織 / 7:ロール / 8:Call元に結果を返却用 */
	const signUp = (username, password, email, familyname, givenname, organization, role = "0000", callback) => {

		consoleLogOutput && (console.log("use-auth useProvideAuth signUp IN", consoleLogOutput));
		consoleLogOutput && (console.log("username:" + username, consoleLogOutput));
		consoleLogOutput && (console.log("password:" + password, consoleLogOutput));
		consoleLogOutput && (console.log("email:" + email, consoleLogOutput));
		consoleLogOutput && (console.log("familyname:" + familyname, consoleLogOutput));
		consoleLogOutput && (console.log("organization:" + organization, consoleLogOutput));
		consoleLogOutput && (console.log("role:" + role, consoleLogOutput));

		Auth.signUp({
			username,
			password,
			attributes: {
				email: email,
				family_name: familyname,
				given_name: givenname,
				"custom:organization": organization,
				"custom:role": role,
			}
		}
		)
			.then(() => {	//正常

				consoleLogOutput && (console.log("use-auth useProvideAuth signUp Auth.signUp OK", consoleLogOutput));

				setUsername(username);
				setPassword(password);
				setEmail(email);
				setFamilyName(familyname);
				setGivenName(givenname);
				setOrganization(organization);
				setRole(role);
				callback({ isSuccessed: true, message: "" });
			})
			.catch((e) => {	//異常
				callback({ isSuccessed: false, location: "signUp", message: I18n.get(e.message) });
				consoleLogOutput && (console.log("use-auth useProvideAuth signUp Auth.signUp OUT(abnormal)", consoleLogOutput, "e"));
			});
		consoleLogOutput && (console.log("use-auth useProvideAuth signUp OUT", consoleLogOutput));
	};

	/*------ ConfirmSignUp ------*/
	/* パラメーター　1:認証コード / 2:Call元に結果を返却用 */
	const confirmSignUp = async (code, callback) => {

		consoleLogOutput && (console.log("use-auth useProvideAuth confirmSignUp IN", consoleLogOutput));
		consoleLogOutput && (console.log("1username:" + username, consoleLogOutput));
		consoleLogOutput && (console.log("1code:" + code, consoleLogOutput));

		Auth.confirmSignUp(username, code)
			.then(() => {	//正常
				consoleLogOutput && (console.log("use-auth useProvideAuth Auth.confirmSignUp IN", consoleLogOutput));
				consoleLogOutput && (console.log("2username:" + username, consoleLogOutput));
				consoleLogOutput && (console.log("2code:" + code, consoleLogOutput));

				/*------ 認証コードの承認がOKならサインイン ------*/
				signIn(username, password, callback);

				consoleLogOutput && (console.log("use-auth useProvideAuth confirmSignUp Auth.confirmSignUp OUT(normal)", consoleLogOutput));
			})
			.catch((e) => {	//異常

				consoleLogOutput && (console.log("use-auth useProvideAuth Auth.confirmSignUp IN(abnormal)", consoleLogOutput, "e"));

				setPassword("");
				callback({ isSuccessed: false, location: "confirmSignUp", message: I18n.get(e.message) });
				consoleLogOutput && (console.log("use-auth useProvideAuth confirmSignUp Auth.confirmSignUp OUT(abnormal)", consoleLogOutput, "e"));
			});
		outputLog("use-auth useProvideAuth confirmSignUp OUT", consoleLogOutput);
		consoleLogOutput && (console.log("use-auth useProvideAuth confirmSignUp OUT", consoleLogOutput));
	};

	/*------ SignIn ------*/
	/* パラメーター　1:email(SignIn ID) / 2:パスワード / 3:Call元に結果を返却用 */
	const signIn = (username, password, callback) => {

		consoleLogOutput && (console.log("use-auth signIn IN", consoleLogOutput));
		consoleLogOutput && (console.log("username:" + username, consoleLogOutput));

		/*------ cognito認証 ------*/
		Auth.signIn(username, password)
			.then((user) => {	//正常
				
				outputLog("use-auth Auth.signIn normal IN", consoleLogOutput);

				/*------ パスワード変更要求時はパスワード変更画面に遷移するよう、messageに"NEW_PASSWORD_REQUIRED"をセット ------*/
				if (user.challengeName === "NEW_PASSWORD_REQUIRED") {	//パスワード変更要求

					outputLog("パスワー変更要求あり", consoleLogOutput);

					callback({ isSuccessed: true, message: "NEW_PASSWORD_REQUIRED" });
					
				} else {	//正常


					setPassword("");
					setIsAuthenticated(true);

					outputLog("use-auth Auth.signIn OUT(normal)", consoleLogOutput);
					callback({ isSuccessed: true, message: "" });
	

						
				}
				// 
			})
			.catch((e) => {	//異常

				outputLog("use-auth Auth.signIn OUT(abnormal)", consoleLogOutput, "e");
				outputLog(e, consoleLogOutput, "e");
				callback({ isSuccessed: false, location: "signIn", message: I18n.get(e.message) });
			});
	};


	/*------ 初回サインインパスワード変更 ------*/
	const completeNewPassword = (email, oldPassword, newPassword, callback) => {

		// console.log("email:" + email + " oldPassword:" + oldPassword);

		Auth.signIn(email, oldPassword)
		// Auth.currentAuthenticatedUser()
		.then(user1 => {
			
			outputLog(user1, consoleLogOutput);

			/*------ パスワード送信 ------*/
			Auth.completeNewPassword(user1, newPassword)
				.then((user2) => {	//正常

					outputLog("use-auth Auth.completeNewPassword OUT(normal)", consoleLogOutput);
					outputLog(user2, consoleLogOutput);
					callback({ isSuccessed: true, message: "" });

				})
				.catch((e) => {	//異常


					outputLog("use-auth Auth.completeNewPassword OUT(abnormal)", consoleLogOutput, "e");
					outputLog(e, consoleLogOutput, "e");
					callback({ isSuccessed: false, location: "completeNewPassword", message: I18n.get(e.message) });
				});

		}).catch(e => {
			callback({ isSuccessed: false, location: "completeNewPassword", message: I18n.get(e.message) });

		});

	};

	/*------ SignOut ------*/
	/* パラメーター　1:Call元に結果を返却用 */
	const signOut = (callback) => {

		Auth.signOut({ global: true })
			.then(() => {	//正常
				setUsername("");
				setEmail("");
				setRole("");
				setIsAuthenticated(false);
				setIsLoading(false);

				sessionStorage.clear();	//セッションストレージを全消去

				outputLog("use-auth signOut OUT", consoleLogOutput);


				callback({ isSuccessed: true, message: "" });
			})
			.catch((e) => {	//異常
				callback({ isSuccessed: false, location: "signOut", message: I18n.get(e.message) });
			});
	};

	/*------ resendSignUp(認証コード再送) ------*/
	const resendSignUp = (callback) => {

		outputLog("use-auth useProvideAuth resendSignUp IN", consoleLogOutput);

		Auth.resendSignUp(username)
			.then(() => {	//正常
				outputLog("use-auth useProvideAuth Auth.resendSignUp IN", consoleLogOutput);
				outputLog("username:" + username);

				callback({ isSuccessed: true, message: "" });
				outputLog("use-auth useProvideAuth resendSignUp Auth.resendSignUp OUT(normal)", consoleLogOutput);
			})
			.catch((e) => {	//異常

				outputLog("use-auth useProvideAuth Auth.resendSignUp IN(abnormal)", consoleLogOutput);

				setPassword("");
				callback({ isSuccessed: false, location: "resendSignUp", message: I18n.get(e.message) });
				outputLog("use-auth useProvideAuth resendSignUp Auth.resendSignUp OUT(abnormal)", consoleLogOutput, "e");
			});
		outputLog("use-auth useProvideAuth resendSignUp OUT", consoleLogOutput);
	};

	/*------ sendEmail(リセットメールアドレス送信) ------*/
	const sendEmail = (username, callback) => {

		/*------ メール送信 ------*/
		Auth.forgotPassword(username)
			.then(() => {	//正常

				callback({ isSuccessed: true, message: "" });

			})
			.catch((e) => {	//異常

				callback({ isSuccessed: false, location: "sendEmail", message: I18n.get(e.message) });
			});
	};

	/*------ sendEmail(リセットメールアドレス送信) ------*/
	const resetPassword = (username, code, newPassword, callback) => {

		/*------ パスワード送信 ------*/
		Auth.forgotPasswordSubmit(username, code, newPassword,)
			.then(() => {	//正常

				callback({ isSuccessed: true, message: "" });

			})
			.catch((e) => {	//異常

				callback({ isSuccessed: false, location: "resetPassword", message: I18n.get(e.message) });
			});
	};

	outputLog("useProvideAuth OUT", consoleLogOutput);

	return {
		isLoading,
		isAuthenticated,
		setIsAuthenticated,
		username,
		password,
		email,
		familyname,
		givenname,
		organization,
		role,
		sendEmail,
		completeNewPassword,
		resetPassword,
		signUp,
		confirmSignUp,
		signIn,
		signOut,
		resendSignUp,
	};
};
